import { Injectable } from "@angular/core";
import { AngularFireMessaging } from "@angular/fire/compat/messaging";
import { BehaviorSubject } from "rxjs";
import { take } from "rxjs/operators";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { NotificationRequestComponent } from "../components/notification-request/notification-request.component";
import {
  HorizontalPosition,
  NotificationService,
  NotificationType,
  VerticalPosition,
} from "./notification.service";
import { NotificationHistoryService } from "./notification-history.service";
import { PaginationParams } from "../models/generic-resource-model";
import { NotificationHistory } from "../models/notification-history.model";
import { DevicePushToken } from "src/app/user-management/models/device-push-token.model";
import * as Bowser from "bowser";
import { DevicePushTokenService } from "src/app/user-management/services/device-push-token.service";
@Injectable({ providedIn: "root" })
export class FirebaseMessagingService {
  totalNotifications: BehaviorSubject<number> = new BehaviorSubject(0);
  notifications: BehaviorSubject<NotificationHistory[]> = new BehaviorSubject(
    null
  );
  showRequest = false;
  currentUserID: number;
  token: string;
  permissionStatus: boolean = false;

  constructor(
    private readonly messaging: AngularFireMessaging,
    private dialog: MatDialog,
    private deviceTokenService: DevicePushTokenService,
    private notificationHistoryService: NotificationHistoryService,
    private snackNotificationService: NotificationService
  ) {}

  get getTotalNotifications() {
    return this.totalNotifications.getValue();
  }

  subscribeNotifications() {
    this.messaging.messages.subscribe((result) => {
      if (result.data?.UserID && this.currentUserID) {
        if (result.data?.UserID != this.currentUserID.toString()) return;
      }

      this.snackNotificationService.showNotification(
        VerticalPosition.bottom,
        HorizontalPosition.right,
        NotificationType.info,
        result.notification.body,
        "notifications_active"
      );

      this.updateNotifications(this.currentUserID);
    });
  }

  requestToken() {
    // Request notifications from browser
    // this.messaging.requestPermission.subscribe(console.log, console.error);

    // Request token if not granted then register token
    return this.messaging.requestToken;
  }

  removeToken() {
    return this.messaging.deleteToken(this.token);
  }

  getToken() {
    return this.messaging.getToken.toPromise();
  }

  async requestNotificationDialog() {
    this.subscribeNotifications();

    this.token = await this.messaging.getToken.toPromise();
    if (this.token) return;

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.position = {
      bottom: "5vh",
    };
    const dialogRef = this.dialog.open(
      NotificationRequestComponent,
      dialogConfig
    );

    dialogRef.afterClosed().subscribe((result) => {
      //condition when click on cancel
      if (result == false) this.permissionStatus = true;
      //condition when click active notification
      if (result == true) {
        this.requestToken()
          .pipe(take(1))
          .toPromise()
          .then((token) => {
            if (!token) return;
            const browser = Bowser.getParser(window.navigator.userAgent);
            let deviceIdentifier = `${browser.getBrowserName()} - ${browser.getOSName()}${browser.getOSVersion()}`;
            // POST TOKEN
            let pushToken: DevicePushToken = new DevicePushToken();
            (pushToken.id = 0), (pushToken.userID = this.currentUserID);
            pushToken.deviceIdentifier = deviceIdentifier;
            pushToken.token = token;
            this.deviceTokenService
              .create(pushToken)
              .toPromise()
              .then(
                (res) => {
                  this.token = token;
                  this.snackNotificationService.showSuccessNotification(
                    "Se activaron las notificaciones"
                  );
                },
                (error) => {
                  console.log(error);
                }
              );
          });
      }
    });
  }

  updateNotifications(userID: number) {
    if (!userID) return;
    this.currentUserID = userID;
    let params: PaginationParams = {
      PageNumber: 1,
      OrderBy: "SendDate desc",
      PageSize: 6,
    };

    this.notificationHistoryService
      .getLastestPaginated<NotificationHistory>(userID, params)
      .toPromise()
      .then(
        (res) => {
          this.notifications.next(res.body);
          this.totalNotifications.next(res.pagination.TotalCount);
        },
        (error) => console.log(error)
      );
  }

  markNotificationsAsRead() {
    if (!this.currentUserID) return;
    this.notificationHistoryService
      .markNotificationsAsRead(this.currentUserID)
      .toPromise()
      .then(
        (res) => {
          this.updateNotifications(this.currentUserID);
        },
        (error) => console.log(error)
      );
  }

  markSingleNotificationsAsRead(id: number) {
    if (!id) return;
    this.notificationHistoryService
      .markSingleNotificationAsRead(id)
      .toPromise()
      .then(
        (res) => {
          this.updateNotifications(this.currentUserID);
        },
        (error) => console.log(error)
      );
  }
}
